/** The only drag payload is an asset ID. No File, URL, pixels, or project object. */
export const LINEMPO_ASSET_MIME = "application/x-linempo-asset-id";
export function readDraggedAssetId(dataTransfer) {
    const value = dataTransfer.getData(LINEMPO_ASSET_MIME);
    return value.trim() ? value : null;
}
export function hasDraggedAsset(dataTransfer) {
    return Array.from(dataTransfer.types).includes(LINEMPO_ASSET_MIME);
}
